const EmptyContent = () => {
  return (
    <div className="p-2 pt-0">
      <div>
        <p className="text-[#5E5BA7] text-[16px] mt-4 mb-4"></p>
      </div>
      <div className="grid justify-center mt-24">
        <i className="fas fa-file-alt text-[#bcbcbd] text-[100px]"></i>
      </div>
      <div className="grid justify-center mt-4">
        <p className="text-[20px] grid justify-center text-center">No Document Found</p>
        <div className="grid justify-center mt-4  md:w-[376px]"></div>
      </div>

      <div></div>
    </div>
  );
};

export default EmptyContent;
